import { Theme } from '@mui/material/styles';
//
import { InputSelectIcon } from './CustomIcons';

// ----------------------------------------------------------------------

export default function Select(theme: Theme) {
  return {
    MuiSelect: {
      defaultProps: {
        IconComponent: InputSelectIcon,
      },
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            backgroundColor: 'rgba(145, 158, 171, 0.025)',
          },
          div: {
            marginRight: theme.spacing(3),
            '&.Mui-disabled': {
              WebkitTextFillColor: '#000000',
            },
          }
        },
      },
    }
  }
}